import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import { getSession } from '@/lib/supabase';

export function AuthCallback() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const { data: { session }, error: sessionError } = await getSession();

        if (sessionError) {
          console.error('Session error:', sessionError);
          throw sessionError;
        }

        if (!session?.user) {
          throw new Error('No user found in session');
        }

        console.log('Phone verification successful');
        
        // Redirect to dashboard or home
        navigate('/dashboard');
        
        toast({
          title: 'Success',
          description: 'Your phone number has been verified.',
        });
      } catch (err: any) {
        console.error('Verification error:', err);
        setError(err.message);
        toast({
          title: 'Error',
          description: err.message,
          variant: 'destructive',
        });
      }
    };

    handleCallback();
  }, [navigate, toast]);

  return (
    <Card className="w-[400px] mx-auto mt-8">
      <CardHeader>
        <CardTitle>Verifying Your Account</CardTitle>
        <CardDescription>
          Please wait while we confirm your details.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center p-6">
        {error ? (
          <div className="text-center text-red-500">
            <p>Verification failed:</p>
            <p>{error}</p>
          </div>
        ) : (
          <div className="flex flex-col items-center space-y-4">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <p>Verifying your account...</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default AuthCallback; 